import { createSlice } from '@reduxjs/toolkit'

// general imports
import {
  ApiRequestDataType,
  ApiRequestStatus,
  StoredErrorResponseType,
} from '../../../types/api/api.types'
import { approveIndividualRequestThunk } from '../thunks/approval-request.thunks'

export type approvalRequestsState = {
  // eslint-disable-next-line
  requestResponse: ApiRequestDataType<any>
}

export const initialState: approvalRequestsState = {
  requestResponse: {
    status: ApiRequestStatus.IDLE,
    data: null,
  },
}

const approveIndividualRequestSlice = createSlice({
  name: 'approveIndividualRequestSlice',
  initialState: initialState,
  reducers: {
    resetApproveIndividualRequest: (state) => {
      ;(state.requestResponse.status = ApiRequestStatus.IDLE), (state.requestResponse.data = null)
      // (state.organizations = {} as OrganizationResponseTypes)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(approveIndividualRequestThunk.pending, (state) => {
        state.requestResponse.status = ApiRequestStatus.PENDING
        state.requestResponse.data = null
        state.requestResponse.error = {} as StoredErrorResponseType
      })
      .addCase(approveIndividualRequestThunk.fulfilled, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.FULFILLED
        state.requestResponse.data = action.payload
      })
      .addCase(approveIndividualRequestThunk.rejected, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as StoredErrorResponseType
      })
  },
})

export const { resetApproveIndividualRequest } = approveIndividualRequestSlice.actions
export default approveIndividualRequestSlice.reducer
